import { User, UserType } from "@archetypes/auth";

export const CURRENT_USER_SUB = "{{ currentUser }}";
export const CURRENT_USER_EMAIL = "{{ currentUser.email }}";

export const CURRENT_USER: User = {
  _id: "currentUser",
  name: "Current User",
  sub: CURRENT_USER_SUB,
  email: CURRENT_USER_EMAIL,
  userType: UserType.USER,
  groups: [],
};

export const CURRENT_TIME = "{{ currentTime }}";
export const CURRENT_DATE = "{{ currentDate }}";
export const CURRENT_DATE_TIME = "{{ currentDateTime }}";
export const CURRENT_RESPONSE = {
  key: "{{ currentResponse }}",
  value: "{{ currentResponse }}",
  label: "Current Form Response",
};
